import React from 'react';
import ReactDOM from 'react-dom/client';
import { AdminUI } from './AdminUI';
import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AdminUI/>
  </React.StrictMode>
);